import axios from 'axios';

const surveyApi = {
  async getSurveys() {
    const response = await axios.get('/api/tenant/survey');
    return response.data;
  },
  async getSurveyDashboards() {
    const response = await axios.get('/api/tenant/survey/dashboard');
    return response.data;
  },
  async getSurveysReports(/* Array<String> */ surveyKeys) {
    if (surveyKeys.length === 0) return;
    const response = await axios.get('/api/tenant/survey/reports/' + surveyKeys.join(','));
    return response.data;
  },
  async getSurveysReportsBySurveyShareKeys(/* Array<String> */ surveyShareKeys) {
    if (surveyShareKeys.length === 0) return;
    const response = await axios.get('/api/tenant/survey/reports/bysurveysharekeys/' + surveyShareKeys.join(','));
    return response.data;
  },
  async getSurvey(key) {
    const response = await axios.get(`/api/tenant/survey/${key}`);
    return response.data;
  },
  async getSurveyStatistics(surveyKey) {
    const response = await axios.get(`/api/tenant/survey/${surveyKey}/statistics`);
    return response.data;
  },
  async getSurveyStatisticsBySurveyShareKey(surveyKey, surveyShareKey) {
    const response = await axios.get(`/api/tenant/survey/${surveyKey}/statistics/${surveyShareKey}`);
    return response.data;
  },
  async createSurvey(survey) {
    const response = await axios.post('/api/tenant/survey', survey);
    return response.data;
  },
  async updateSurvey(survey) {
    const response = await axios.put(`/api/tenant/survey/${survey.key}`, survey);
    return response.data;
  },
  async deleteSurvey(key) {
    const response = await axios.delete(`/api/tenant/survey/${key}`);
    return response.data;
  },
  async calculateResult(key) {
    const response = await axios.get(`/api/tenant/survey/${key}/calculate`);
    return response.data;
  },
  async getCalculation(key) {
    const response = await axios.get(`/api/tenant/survey/${key}/calculation`);
    return response.data;
  },
  async saveSurveySubscription(key, notificationType) {
    const response = await axios.get(`/api/tenant/survey/${key}/notification/${notificationType}`);
    return response.data;
  },
};

export default surveyApi;
